import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepKey } from '../../../core/enums/stepper.enum';
import { FunnelService } from '../../../features/users/components/funnel/funnel.service';

@Component({
  selector: 'app-back-button',
  standalone: false,
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss'
})
export class BackButtonComponent {

  @Input() currentStep!: StepKey;
  @Input() firstStep: StepKey = StepKey.Vehicle;
  @Input() lastStep: StepKey = StepKey.Overview;

  @Output() goBack = new EventEmitter<void>();
  @Output() goNext = new EventEmitter<void>();

  StepKey = StepKey;
  brandingId = '';
  
  constructor(private funnelService: FunnelService) {
    this.funnelService.getBrandingStyles(this.brandingId).subscribe((data) => {
      console.log('Branding styles:', data);
    
      document.documentElement.style.setProperty('--background-color', data.BackgroundColor);
      document.documentElement.style.setProperty('--text-color', data.TextColor);
      document.documentElement.style.setProperty('--button-text-color', data.ButtonTextColor);
    
      if (data.ButtonColor.length > 1) {
        document.documentElement.style.setProperty('--button-gradient-start', data.ButtonColor[0]);
        document.documentElement.style.setProperty('--button-gradient-middle', data.ButtonColor[1]);
        document.documentElement.style.setProperty('--button-gradient-end', data.ButtonColor[2]);
      } else {
        document.documentElement.style.setProperty('--button-gradient-start', data.ButtonColor[0]);
        document.documentElement.style.setProperty('--button-gradient-end', data.ButtonColor[0]);
      }
    });
  }

}
